import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ConfigService } from '../config.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class TealiumUtagService {
    environment = environment;
    scriptSrc = 'https://c.woopic.com/libs/common/o_load_responsive.js';
    private init: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public init$: Observable<boolean> = this.init.asObservable();

    // Typically set "noview" flag (no first page automatic view event) to true for Single Page Apps (SPAs)
    constructor(
        private configService: ConfigService,
    ) {
        (window as any).utag_cfg_ovrd = { noview: true };
        (window as any).utag_data = {};
        
        this.setConfigCommon();

        const elcom = window.document.createElement('script');
        elcom.type = 'text/javascript';
        elcom.src = this.scriptSrc;
        window.addEventListener("utag:loaded", () => {
            if ((window as any).utag != undefined) {
                console.log("utag:loaded", (window as any).utag)
                this.init.next(true);
            }
        })
        document.body.appendChild(elcom);

    }

    setConfigCommon = () => {
        (window as any).o_confCommon = {
            ...(window as any).o_confCommon,
            headerDisplay: false,
            typeEnv: this.environment.production ? 'prod' : 'rec',
            tracking: {
                Tealium: {
                    idBased: true,
                    instanceUrl: `https://tags.tiqcdn.com/utag/${this.configService.config.account}/${this.configService.config.profile}/${this.environment.production ? 'prod' : 'qa'}/utag.js`,
                    profile: `${this.configService.config.profile}`,
                    deactivate: false,
                    autoLoad: {
                        sync: true,
                        async: true
                    }
                }
            }
        };
        (window as any).o_data = (window as any).o_data || {};
    }

    view(typePage?: string, titrePage?: string, universAffichage?: string, sousUnivers?: string, trackingId?: string) {
        this.init$.subscribe((bool) => {
            console.log('bool', bool);
            console.log("trackingId", trackingId);
            if (bool) {
                // (window as any).o_data.ns_site = environment.production ? 'orange-france' : 'orange-france-test';
                // (window as any).o_data.type_page = typePage;
                // (window as any).o_data.segment = "RES";
                // (window as any).o_data.couleur = "Orange";
                // (window as any).o_data.titre_page = titrePage;
                // (window as any).o_data.domaine = "Communication";
                // (window as any).o_data.univers_affichage = universAffichage;
                // (window as any).o_data.sous_univers = sousUnivers;
                // (window as any).o_data.trackingId = trackingId;
                (window as any).o_utagview(
                    { 
                        "ns_site": environment.production ? 'orange-france' : 'orange-france-test',
                        "type_page": typePage,
                        "segment": "RES",
                        "couleur": "Orange",
                        "titre_page": titrePage,
                        "domaine": "Communication",
                        "univers_affichage": universAffichage,
                        "sous_univers": sousUnivers,
                        "id_tracking": trackingId,
                        "isIdTracking": trackingId != null ? "true" : "false"
                    }
                );
            }
        });
    }

    link(data?: any) {
        this.init$.subscribe((bool) => {
            console.log('link', bool);
            if (bool) {
                Object.keys((window as any).o_data).forEach(key => {
                   if ((window as any).utag_data[key] != undefined ) {
                        (window as any).o_data[key] = (window as any).utag_data[key];
                   };
                });
                (window as any).o_link({...(window as any).o_data, ...data });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/tealium/utag.service.ts